import { dataNeutralFace } from 'dls-icons-data'
import { createIcon } from '../common'

const IconNeutralFace = /*#__PURE__*/createIcon(dataNeutralFace)
export default IconNeutralFace
